export const modalSlug = 'rich-text-link-modal'
export const linkFieldsSchemaPath = 'link.fields'
